module.exports = __webpack_public_path__ + "img/route.b9fc49bf.svg";